export const getSearchPaginationSummaryText = (pageNum, totalResultsCount, defaultPageSize = 10) => {
  const showingFrom = pageNum > 1 ? (pageNum - 1) * defaultPageSize + 1 : 1;
  let showingTo = totalResultsCount < defaultPageSize ? totalResultsCount : pageNum * defaultPageSize;

  if (showingTo > totalResultsCount) {
    showingTo = totalResultsCount;
  }

  return `Showing ${showingFrom}-${showingTo} of ${totalResultsCount} result${totalResultsCount > 1 ? 's' : ''}`;
};

/**
 * Returns the object if an attribute value in a property in the object
 *
 * @param {Array} containingArray Array of objects
 * @param {string|*} attribute Attribute of the object to match to the attributeValue
 * @param {string|*} attributeValue Value to match to an item in an object
 * @returns {object} Matched object
 */
export const findItemWithAttribute = (containingArray, attribute, attributeValue) => {
  if (containingArray && Array.isArray(containingArray)) {
    return containingArray.find((containingArrayItem) => {
      if (typeof containingArrayItem[attribute] === 'string' && typeof attributeValue === 'string') {
        return containingArrayItem[attribute].trim() === attributeValue.trim();
      }
      return containingArrayItem[attribute] === attributeValue;
    });
  }
  return null;
};
